import createIcon from '../../createIcon';

/**
 * @component @name DeviceThermostat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTNWNUMxNSAzLjM0IDEzLjY2IDIgMTIgMkMxMC4zNCAyIDkgMy4zNCA5IDVWMTNDNy43OSAxMy45MSA3IDE1LjM3IDcgMTdDNyAxOS43NiA5LjI0IDIyIDEyIDIyQzE0Ljc2IDIyIDE3IDE5Ljc2IDE3IDE3QzE3IDE1LjM3IDE2LjIxIDEzLjkxIDE1IDEzWk0xMSA1QzExIDQuNDUgMTEuNDUgNCAxMiA0QzEyLjU1IDQgMTMgNC40NSAxMyA1SDEyVjZIMTNWOEgxMlY5SDEzVjExSDExVjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeviceThermostat = createIcon('DeviceThermostat', [
  [
    'path',
    {
      d: 'M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5H12V6H13V8H12V9H13V11H11V5Z',
      key: 'hrae7e',
    },
  ],
]);

export default DeviceThermostat;
